import {useIntl} from 'react-intl'
import {
    GENERAL_FORM_VALIDATION_MESSAGES as generalMessages,
    VALIDATE_EMAIL_PATTERN
} from '../../constants'

export default function useGlobalFields({
    form: {
        control,
        formState: {errors}
    },
    prefix = ''
}) {
    const {formatMessage} = useIntl()
    const firstNameLabel = formatMessage({
        defaultMessage: 'First Name',
        id: 'use_address_fields.label.first_name'
    })
    const lastNameLabel = formatMessage({
        defaultMessage: 'Last Name',
        id: 'use_address_fields.label.last_name'
    })

    const phoneLabel = formatMessage({
        defaultMessage: 'Phone Number',
        id: 'use_profile_fields.label.phone'
    })

    const emailLabel = formatMessage({defaultMessage: 'Email', id: 'use_login_fields.label.email'})

    return {
        firstName: {
            name: `${prefix}firstName`,
            label: firstNameLabel,
            placeholder: formatMessage({
                defaultMessage: 'Enter your first name',
                id: 'newsletter_banner.text.first_name_field_placeholder'
            }),
            type: 'text',
            defaultValue: '',
            inputProps: {
                autoComplete: 'given-name'
            },
            rules: {
                required: formatMessage({
                    defaultMessage: 'Please enter your first name.',
                    id: 'use_address_fields.error.please_enter_first_name'
                }),
                maxLength: {
                    message: formatMessage(generalMessages.maxLength, {
                        label: firstNameLabel,
                        n: 40
                    }),
                    value: 40
                }
            },
            error: errors[`${prefix}firstName`],
            control
        },
        lastName: {
            name: `${prefix}lastName`,
            label: lastNameLabel,
            placeholder: formatMessage({
                defaultMessage: 'Enter your last name',
                id: 'newsletter_banner.text.last_name_field_placeholder'
            }),

            type: 'text',
            defaultValue: '',
            inputProps: {
                autoComplete: 'family-name'
            },
            rules: {
                required: formatMessage({
                    defaultMessage: 'Please enter your last name.',
                    id: 'use_address_fields.error.please_enter_last_name'
                }),
                maxLength: {
                    message: formatMessage(generalMessages.maxLength, {
                        label: lastNameLabel,
                        n: 50
                    }),
                    value: 50
                }
            },
            error: errors[`${prefix}lastName`],
            control
        },
        phone: {
            name: `${prefix}phone`,
            label: phoneLabel,
            defaultValue: '',
            type: 'tel',
            rules: {
                required: formatMessage({
                    defaultMessage: 'Please enter your phone number.',
                    id: 'use_address_fields.error.please_enter_your_phone_number'
                }),
                pattern: {
                    value: /^[0-9\s+\-()]+$/,
                    message: formatMessage({
                        defaultMessage: 'Please enter a valid phone number.',
                        id: 'use_address_fields.error.please_enter_valid_phone_number'
                    })
                },
                maxLength: {
                    message: formatMessage(generalMessages.maxLength, {
                        label: phoneLabel,
                        n: 20
                    }),
                    value: 20
                }
            },
            error: errors[`${prefix}phone`],
            inputProps: {
                autoComplete: 'tel'
            },
            control
        },
        email: {
            name: `${prefix}email`,
            label: emailLabel,
            placeholder: 'you@email.com',
            defaultValue: '',
            type: 'email',
            rules: {
                required: formatMessage({
                    defaultMessage: 'Please enter your email address.',
                    id: 'use_login_fields.error.required_email'
                }),
                pattern: {
                    value: VALIDATE_EMAIL_PATTERN,
                    message: formatMessage({
                        defaultMessage: 'Please enter a valid email address.',
                        id: 'use_login_fields.error.pattern_email'
                    })
                },
                maxLength: {
                    message: formatMessage(generalMessages.maxLength, {
                        label: emailLabel,
                        n: 50
                    }),
                    value: 50
                }
            },
            error: errors[`${prefix}email`],
            inputProps: {
                autoComplete: 'email'
            },
            control
        }
    }
}
